/* Delfino — product-video-testimonials v2 („social proof loop", Task 30).
   Portare a source/naturvia/social-proof-loop.js pe convențiile temei: rândul de mărturii se
   derulează la infinit, singur, iar clipurile rulează în card fără sunet până când cineva apasă
   butonul de sunet al unui card.

   De ce JS propriu și nu cârligele din theme.js:
   - `DL.marquee` clonează pista o singură dată (innerHTML dublat) și derulează prin scrollLeft —
     nu acoperă lățimi mari de card, nu re-măsoară la resize și nu știe de clipuri;
   - `DL.lazyVideo` pune `src` pe clip și îl uită: nu-l oprește când iese din ecran, nu poate ține
     „un singur card cu sunet" și nu respectă Data Saver.
   Cârligele proprii: [data-dl-tc] (rădăcină), [data-dl-tc-loop], [data-dl-tc-track],
   [data-dl-tc-card]. Clipurile NU au data-dl-lazy-video, rădăcina NU are data-dl-marquee, tocmai
   ca DL.lazyVideo/DL.marquee să nu le preia și ele.

   Patru părți, ca pe naturvia:
   1. Buclă infinită — clonăm setul de carduri până când pista acoperă ecranul + un set întreg;
      clonele sunt aria-hidden, butoanele lor ies din ordinea de tabulare, iar atributul de editor
      (data-shopify-editor-block) e scos, ca editorul de teme să nu creadă că sunt blocuri reale.
   2. Clipuri leneșe — IntersectionObserver cu marjă 300 px atașează <source> abia când cardul se
      apropie de ecran (preload="none" în markup) și pune clipul pe pauză când iese. Cu Data Saver
      pornit nu se încarcă nimic: rămâne posterul.
   3. Derulare pe requestAnimationFrame (nu animație CSS — pe iOS animația se blochează la
      scroll), cu pauză la hover, la focus din tastatură, când tab-ul e ascuns, cât timp un card
      are sunetul pornit și cât timp un bloc e selectat în editorul de teme.
   4. Sunet — un singur card poate avea sunet; butonul comută aria-pressed + eticheta („Pornește
      sunetul" / „Oprește sunetul") și oprește derularea cât timp se ascultă.

   „Mișcare redusă" (prefers-reduced-motion): nu clonăm și nu derulăm nimic — rândul rămâne exact
   cardurile originale, derulabile cu degetul/trackpad-ul (fără clasa `is-ready`, CSS-ul păstrează
   overflow-x:auto). Clipurile rămân leneșe, dar nu pornesc singure.

   Idempotent (data-bound pe rădăcină) și cu teardown prin DL.onDestroy — editorul de teme aruncă
   nodul secțiunii la fiecare modificare, iar rAF-ul și listenerii de pe window/document ar
   supraviețui nodului. */
(function () {
  'use strict';

  var MOBILE_BP = 750;
  var initVia = 'direct';
  var LABEL_UNMUTE = 'Pornește sunetul';
  var LABEL_MUTE = 'Oprește sunetul';

  function soundState(card, on) {
    var btn = card.querySelector('.pp-tc-sound');
    if (!btn) return;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? LABEL_MUTE : LABEL_UNMUTE);
  }

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* pornirea automată blocată de browser — posterul rămâne */ });
  }

  function bind(root) {
    root.dataset.bound = '1';
    root.dataset.dlTcVia = initVia; /* pe ce cale am fost inițializați — util la depanare și în verificarea din browser */

    var loop = root.querySelector('[data-dl-tc-loop]');
    var track = root.querySelector('[data-dl-tc-track]');
    if (!loop || !track) return;
    var originals = [].slice.call(track.children);
    if (!originals.length) return;

    var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(conn && conn.saveData);
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !saveData && !reducedMotion;
    var pauseOnHover = root.getAttribute('data-pause-hover') === 'true';
    var speedDesktop = parseFloat(root.getAttribute('data-speed')) || 40;
    var speedMobile = parseFloat(root.getAttribute('data-speed-mobile')) || 50;

    var setWidth = 0;
    var offset = 0;
    var prevTs = 0;
    var rafTick = 0;
    var rafResize = 0;
    var io = null;
    var hoverPaused = false;
    var focusPaused = false;
    var hiddenPaused = false;
    var soundPaused = false;
    var editorPaused = false;
    var pxPerSec = window.innerWidth < MOBILE_BP ? speedMobile : speedDesktop;

    /* ---------- 1. Buclă infinită ---------- */
    function measureSet() {
      var first = originals[0];
      var last = originals[originals.length - 1];
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      setWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;
    }

    function fillClones() {
      track.querySelectorAll('[data-dl-tc-clone]').forEach(function (c) { c.remove(); });
      measureSet();
      if (!setWidth) return;
      var need = loop.clientWidth + setWidth;
      var guard = 0;
      while (track.scrollWidth < need && guard < 20) {
        originals.forEach(function (el) {
          var c = el.cloneNode(true);
          c.setAttribute('data-dl-tc-clone', '1');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          c.classList.remove('is-unmuted');
          var btn = c.querySelector('.pp-tc-sound');
          if (btn) { btn.setAttribute('tabindex', '-1'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', LABEL_UNMUTE); }
          var v = c.querySelector('video');
          if (v) v.muted = true;
          track.appendChild(c);
        });
        guard++;
      }
      /* Dacă sunetul era pornit pe o CLONĂ, clona tocmai a fost ștearsă și rescrisă mută — fără
         linia asta `soundPaused` rămânea true și rândul înțepenea definitiv după un resize. */
      soundPaused = !!track.querySelector('[data-dl-tc-card].is-unmuted');
      observeVideos();
    }

    /* ---------- 2. Clipuri leneșe ---------- */
    function armVideo(card) {
      var v = card.querySelector('video');
      if (!v || v.__dlTcArmed) return v || null;
      v.__dlTcArmed = true;
      var src = v.getAttribute('data-src');
      if (!src) return v;
      if (!v.querySelector('source')) {
        /* clonele copiază <source>-ul deja atașat originalului — nu-l dublăm, doar îl (re)încărcăm */
        var s = document.createElement('source');
        s.src = src;
        s.type = v.getAttribute('data-type') || 'video/mp4';
        v.appendChild(s);
      }
      v.load();
      card.classList.add('is-armed');
      return v;
    }

    function onIntersect(entries) {
      entries.forEach(function (e) {
        var card = e.target;
        var v = card.querySelector('video');
        if (!v) return;
        card.__dlTcVisible = e.isIntersecting;
        if (!e.isIntersecting) { if (!v.paused) v.pause(); return; }
        if (saveData && !card.classList.contains('is-unmuted')) return; /* Data Saver: doar posterul */
        armVideo(card);
        if (autoplay || card.classList.contains('is-unmuted')) play(v);
      });
    }

    function observeVideos() {
      var cards = track.querySelectorAll('[data-dl-tc-card].has-video');
      if (!('IntersectionObserver' in window)) {
        cards.forEach(function (card) {
          if (saveData) return;
          var v = armVideo(card);
          if (v && autoplay) play(v);
        });
        return;
      }
      if (!io) io = new IntersectionObserver(onIntersect, { root: null, rootMargin: '300px', threshold: 0.01 });
      cards.forEach(function (card) {
        if (card.__dlTcObserved) return;
        card.__dlTcObserved = true;
        io.observe(card);
      });
    }

    function pauseAllVideos() {
      track.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
    }
    /* La întoarcerea în tab, IntersectionObserver-ul NU mai raportează nimic (intersecțiile n-au
       variat cât timp pagina era ascunsă), deci clipurile ar rămâne oprite pentru totdeauna —
       le repornim noi pe cele care erau vizibile. */
    function resumeVisibleVideos() {
      track.querySelectorAll('[data-dl-tc-card].has-video.is-armed').forEach(function (card) {
        if (!card.__dlTcVisible) return;
        var v = card.querySelector('video');
        if (v && v.paused && (autoplay || card.classList.contains('is-unmuted'))) play(v);
      });
    }

    /* ---------- 3. Derulare (rAF) ---------- */
    function isPaused() { return hoverPaused || focusPaused || hiddenPaused || soundPaused || editorPaused; }

    function tick(ts) {
      if (!prevTs) prevTs = ts;
      var dt = Math.min((ts - prevTs) / 1000, 0.1);
      prevTs = ts;
      if (!isPaused() && setWidth > 0) {
        offset += pxPerSec * dt;
        if (offset >= setWidth) offset -= setWidth;
        track.style.transform = 'translate3d(' + -offset.toFixed(2) + 'px,0,0)';
      }
      rafTick = requestAnimationFrame(tick);
    }

    function start() {
      if (reducedMotion) { observeVideos(); return; } /* rând static, derulabil cu degetul */
      fillClones();
      loop.classList.add('is-ready');
      rafTick = requestAnimationFrame(tick);
    }

    /* ---------- 4. Sunet ---------- */
    function onClick(ev) {
      var btn = ev.target.closest && ev.target.closest('.pp-tc-sound');
      if (!btn) return;
      var card = btn.closest('[data-dl-tc-card]');
      if (!card) return;
      var v = armVideo(card);
      if (!v) return;
      var unmute = v.muted; /* mut acum → clicul pornește sunetul */
      track.querySelectorAll('video').forEach(function (other) {
        if (other === v) return;
        other.muted = true;
        var oc = other.closest('[data-dl-tc-card]');
        if (!oc) return;
        oc.classList.remove('is-unmuted');
        soundState(oc, false);
      });
      v.muted = !unmute;
      card.classList.toggle('is-unmuted', unmute);
      soundState(card, unmute);
      soundPaused = unmute; /* cu sunetul pornit oprim derularea, ca omul să poată asculta */
      if (unmute) play(v);
      else prevTs = 0;
    }

    function onResize() {
      cancelAnimationFrame(rafResize);
      rafResize = requestAnimationFrame(function () {
        pxPerSec = window.innerWidth < MOBILE_BP ? speedMobile : speedDesktop;
        if (reducedMotion) return;
        fillClones();
        if (offset >= setWidth) offset = 0;
      });
    }
    function onEnter() { hoverPaused = true; }
    function onLeave() { hoverPaused = false; prevTs = 0; }
    /* Pauză la focus DOAR când focusul vine de la tastatură (:focus-visible). Cu `focusin` pur,
       un simplu click pe butonul de sunet lăsa focusul pe buton, iar rândul rămânea înțepenit
       pentru totdeauna după ce omul punea sunetul la loc pe mut (verificat în Playwright). */
    function onFocusIn(e) {
      var el = e.target;
      try { focusPaused = !!(el && el.matches && el.matches(':focus-visible')); }
      catch (err) { focusPaused = true; } /* browser fără :focus-visible — ne purtăm ca înainte */
    }
    function onFocusOut() { focusPaused = false; prevTs = 0; }
    function onVisibility() {
      hiddenPaused = document.hidden;
      if (hiddenPaused) { pauseAllVideos(); return; }
      prevTs = 0;
      resumeVisibleVideos();
    }

    track.addEventListener('click', onClick);
    if (pauseOnHover) {
      loop.addEventListener('mouseenter', onEnter);
      loop.addEventListener('mouseleave', onLeave);
    }
    loop.addEventListener('focusin', onFocusIn);
    loop.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('resize', onResize);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });

    /* Editorul de teme: cât timp un bloc e selectat, oprim derularea ca să poată fi văzut. */
    root.__dlTc = {
      pause: function () { editorPaused = true; },
      resume: function () { editorPaused = false; prevTs = 0; }
    };

    function cleanup() {
      cancelAnimationFrame(rafTick);
      cancelAnimationFrame(rafResize);
      if (io) { io.disconnect(); io = null; }
      track.removeEventListener('click', onClick);
      loop.removeEventListener('mouseenter', onEnter);
      loop.removeEventListener('mouseleave', onLeave);
      loop.removeEventListener('focusin', onFocusIn);
      loop.removeEventListener('focusout', onFocusOut);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', start);
      pauseAllVideos();
      root.__dlTc = null;
      root.__dlTcCleanup = null;
      delete root.dataset.bound;
      delete root.dataset.dlTcVia;
    }
    if (window.DL && typeof window.DL.onDestroy === 'function') window.DL.onDestroy(root, cleanup);
    else root.__dlTcCleanup = cleanup; /* theme.js lipsă (randare izolată) — curățăm din handler-ul de mai jos */
  }

  function init(root) {
    (root || document).querySelectorAll('[data-dl-tc]:not([data-bound])').forEach(bind);
  }

  function rootOf(el) { return el && el.closest ? el.closest('[data-dl-tc]') : null; }

  document.addEventListener('shopify:section:load', function (e) { initVia = 'section-load'; init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-dl-tc]').forEach(function (r) {
      if (typeof r.__dlTcCleanup === 'function') r.__dlTcCleanup();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var r = rootOf(e.target);
    if (r && r.__dlTc) r.__dlTc.pause();
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var r = rootOf(e.target);
    if (r && r.__dlTc) r.__dlTc.resume();
  });

  function register() {
    if (window.DL && typeof window.DL.use === 'function') { initVia = 'dl-use'; window.DL.use(init); }
    else { initVia = 'fallback'; init(document); } /* theme.js lipsă (randare izolată) */
  }
  /* Înregistrare — momentul contează. Fișierul ăsta e încărcat cu `defer` ȘI înaintea lui theme.js
     (ambele la finalul lui <body>, vezi layout/theme.liquid), deci la execuția lui `window.DL` încă
     nu există. Un `readyState === 'loading'` ar fi MEREU fals aici (scripturile defer rulează în
     faza „interactive"), așa că `register()` ar porni sincron, înainte ca theme.js să definească
     `DL.use`, și am cădea de fiecare dată pe ramura de rezervă — secțiunea ar merge, dar în afara
     cozii de plugin-uri a temei (fără `DL.onDestroy`, fără re-init din `DL.init`). Așteptăm deci
     DOMContentLoaded, când tot codul de nivel superior al scripturilor defer a rulat; doar un
     fișier injectat DUPĂ pornirea paginii (editorul de teme) prinde `readyState === 'complete'` și
     se înregistrează pe loc. Același tipar ca în section-video-testimonials.js. */
  if (document.readyState === 'complete') register();
  else document.addEventListener('DOMContentLoaded', register, { once: true });
})();
